import { Moon, Sun } from 'lucide-react';
import { Button } from '@core-ui/Components/ui/button.tsx';
import { useTheme } from '@core-ui/providers/theme-provider.tsx';
import React, { type JSX } from 'react';
import { cn } from '@core-ui-lib/utils.ts';

interface ModeToggleProps {
  className?: string;
}

export function ModeToggle ({ className }: ModeToggleProps): JSX.Element {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  const toggleTheme = (): void => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <Button
      data-qa-id="theme-button"
      onClick={toggleTheme}
      variant="ghost"
      size="icon"
      aria-label="Toggle dark mode"
      className={cn(
        'h-8 w-8 transition-colors hover:bg-muted dark:hover:bg-muted border border-border cursor-pointer',
        className,
      )}
    >
      {isDark ? (
        <Moon className="h-5 w-5 text-muted-foreground" />
      ) : (
        <Sun className="h-5 w-5 text-muted-foreground" />
      )}
    </Button>
  );
}
